import api from '.';
import { DeleteProjectDocument } from '../pages/DeleteProjectDocument/deleteProjectDocumentSlice';

export interface GetDeleteProjectDocuments {
  projectId: number;
  page: number;
  limit: number;
}

interface ReturnTypeDeleteProjectDocument {
  count: number;
  data: DeleteProjectDocument[];
}

export async function getDeleteProjectDocuments({
  projectId,
  page,
  limit
}: GetDeleteProjectDocuments): Promise<ReturnTypeDeleteProjectDocument> {
  const params = {
    projectId,
    page,
    limit
  };
  const { data } = await api.get('/delete-project-documents', { params });

  return data;
}
